// extracted by mini-css-extract-plugin
module.exports = {"container":"i_ZP","info":"i_ZQ","doughnut":"i_ZR","title":"i_ZS","points":"i_ZT","target":"i_ZU","value":"i_ZV","suffix":"i_ZW"};